import { StatusEnum } from '@cms/api/requests'
import { TFunction } from 'i18next'

export const Status = {
  All: 'all',
  ...StatusEnum
} as const

// Status type is used for api, status from api can be only draft or published
export type StatusType = StatusEnum.PUBLISHED | StatusEnum.DRAFT

export type StatusEntity = {
  value: typeof Status.All | StatusEnum
  label: string
}

export const getStatuses = (t: TFunction): StatusEntity[] => {
  return [
    {
      value: Status.PUBLISHED,
      label: t('table.published')
    },
    {
      value: Status.DRAFT,
      label: t('table.draft')
    }
  ]
}

export const getStatusesTag = (t: TFunction) => {
  return {
    [Status.DRAFT]: { label: t('table.draft'), color: 'default' },
    [Status.PUBLISHED]: { label: t('table.published'), color: 'success' }
  }
}

export const getStatusesOptions = (t: TFunction): StatusEntity[] => {
  return [
    {
      value: Status.All,
      label: t('table.all')
    },
    {
      value: Status.PUBLISHED,
      label: t('table.published')
    },
    {
      value: Status.DRAFT,
      label: t('table.draft')
    }
  ]
}
